import { useQuery } from "react-query";
import { getBaseUrl } from "../utils";

const useGetDiscountedPlans = ({ config, submittedVoucherCode }: { config: any, submittedVoucherCode: string }) => {
  const queryFn = () => fetch(`${getBaseUrl()}/api/billing/user/anon/voucher?voucherCode=${submittedVoucherCode}`, { method: 'GET' }).then(res => {
    if (!res.ok) throw res
    return res.json()
  });

  return useQuery(
    ['validateVoucher', submittedVoucherCode],
    queryFn,
    config
  );
}

export default useGetDiscountedPlans